import { baseApiPath, get, deleteEntity } from "./base-api";
import { IAutoBidJob, IAutoBidStats } from "../data-access";

interface PaginatedResponse<T> {
  data: T[];
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}

interface FilterParams {
  time_period?: string;
  date_from?: string;
  date_to?: string;
  user_id?: string;
  status?: string;
}

const getJobs = (
  page: number = 1,
  perPage: number = 15,
  filters?: FilterParams
): Promise<PaginatedResponse<IAutoBidJob>> => {
  const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
  if (filters?.status) params.append("status", filters.status);
  if (filters?.time_period) params.append("time_period", filters.time_period);
  if (filters?.date_from) params.append("date_from", filters.date_from);
  if (filters?.date_to) params.append("date_to", filters.date_to);
  if (filters?.user_id) params.append("user_id", filters.user_id);
  return get<PaginatedResponse<IAutoBidJob>>(`${baseApiPath}/api/auto-bid?${params}`);
};

const getJob = (id: number): Promise<IAutoBidJob> => {
  return get<IAutoBidJob>(`${baseApiPath}/api/auto-bid/${id}`);
};

const getStats = (filters?: FilterParams): Promise<IAutoBidStats> => {
  const params = new URLSearchParams();
  if (filters?.time_period) params.append("time_period", filters.time_period);
  if (filters?.date_from) params.append("date_from", filters.date_from);
  if (filters?.date_to) params.append("date_to", filters.date_to);
  if (filters?.user_id) params.append("user_id", filters.user_id);
  const qs = params.toString();
  return get<IAutoBidStats>(`${baseApiPath}/api/auto-bid/stats${qs ? '?' + qs : ''}`);
};

export interface IAutoBidGraphResponse {
  labels: string[];
  datasets: {
    scanned: number[];
    submitted: number[];
    replies: number[];
    offers: number[];
  };
}

const getStatsGraph = (params: string): Promise<IAutoBidGraphResponse> => {
  return get<IAutoBidGraphResponse>(`${baseApiPath}/api/auto-bid/stats-graph?${params}`);
};

const clearAll = (): Promise<{ deleted: number }> => {
  return deleteEntity<{ deleted: number }>(`${baseApiPath}/api/auto-bid/clear`);
};

export const autoBiddingApi = {
  getJobs,
  getJob,
  getStats,
  getStatsGraph,
  clearAll,
};
